export const REMOVE_ITEM = 'REMOVE_ITEM';
export const GET_ITEM = 'GET_ITEM';
export const SET_CART = 'SET_CART';
export const CLEAR_CART = 'CLEAR_CART';
export const GET_TOTALS = 'GET_TOTALS';
export const INCREMENT_DECREMENT = 'INCREMENT_DECREMENT';
export const GET_DISCOUNT_REQUEST = 'GET_DISCOUNT_REQUEST';
export const GET_DISCOUNT_SUCCESS = 'GET_DISCOUNT_SUCCESS';
export const GET_DISCOUNT_ERROR = 'GET_DISCOUNT_ERROR';
export const SET_ORDER_ID = 'SET_ORDER_ID';
export const CHECKOUT_CART = 'CHECKOUT_CART';
export const GET_PRODUCTS_REQUEST = 'GET_PRODUCTS_REQUEST';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_ERROR = 'GET_PRODUCTS_ERROR';
export const START_USER_SESSION_REQUEST = 'START_USER_SESSION_REQUEST';
export const START_USER_SESSION_SUCCESS = 'START_USER_SESSION_SUCCESS';
export const START_USER_SESSION_ERROR = 'START_USER_SESSION_ERROR';
export const GET_CUSTOMERS_REQUEST = 'GET_CUSTOMERS_REQUEST';
export const GET_CUSTOMERS_SUCCESS = 'GET_CUSTOMERS_SUCCESS';
export const GET_CUSTOMERS_ERROR = 'GET_CUSTOMERS_ERROR';
export const GET_QUALIFICATIONS_REQUEST = 'GET_QUALIFICATIONS_REQUEST';
export const GET_QUALIFICATIONS_SUCCESS = 'GET_QUALIFICATIONS_SUCCESS';
export const GET_QUALIFICATIONS_ERROR = 'GET_QUALIFICATIONS_ERROR';
export const GET_CAMPAIGNS_REQUEST = 'GET_CAMPAIGNS_REQUEST';
export const GET_CAMPAIGNS_SUCCESS = 'GET_CAMPAIGNS_SUCCESS';
export const GET_CAMPAIGNS_ERROR = 'GET_CAMPAIGNS_ERROR';
export const GET_VOUCHERS_REQUEST = 'GET_VOUCHERS_REQUEST';
export const GET_VOUCHERS_SUCCESS = 'GET_VOUCHERS_SUCCESS';
export const GET_VOUCHERS_ERROR = 'GET_VOUCHERS_ERROR';
export const GET_CURRENT_CUSTOMER_SUCCESS = 'GET_CURRENT_CUSTOMER_SUCCESS';
export const GET_CURRENT_CUSTOMER_REQUEST = 'GET_CURRENT_CUSTOMER_REQUEST';
export const GET_CURRENT_CUSTOMER_ERROR = 'GET_CURRENT_CUSTOMER_ERROR';
export const GET_CART_PROMOTIONS_REQUEST = 'GET_CART_PROMOTIONS_REQUEST';
export const GET_CART_PROMOTIONS_SUCCESS = 'GET_CART_PROMOTIONS_SUCCESS';
export const GET_CART_PROMOTIONS_ERROR = 'GET_CART_PROMOTIONS_ERROR';
export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD';
export const SET_ENABLE_CART_DISCOUNTS = 'SET_ENABLE_CART_DISCOUNTS';
export const SET_CURRENT_CART_DISCOUNT = 'SET_CURRENT_CART_DISCOUNT';
export const REMOVE_CURRENT_CUSTOMER = 'REMOVE_CURRENT_CUSTOMER';
export const REMOVE_DISCOUNT = 'REMOVE_DISCOUNT';
export const ENABLE_SIDEBAR = 'ENABLE_SIDEBAR';
export const DISABLE_SIDEBAR = 'DISABLE_SIDEBAR';
export const ADD_PUBLISHED_CODES = 'ADD_PUBLISHED_CODES';
export const IS_OLD_APP_VERSION = 'IS_OLD_APP_VERSION';
export const SET_CURRENT_APP_VERSION = 'SET_CURRENT_APP_VERSION';
export const PREPARE_MESSAGES = 'PREPARE_MESSAGES';
export const GET_MESSAGE = 'GET_MESSAGE';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';
export const ADD_NEW_CUSTOMERS_SUCCESS = 'ADD_NEW_CUSTOMERS_SUCCESS';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';
export const UPDATE_GIFT_CARD_BALANCE = 'UPDATE_GIFT_CARD_BALANCE';


export const GET_SQUARE_ENVIORNMENT_SUCCESS='GET_SQUARE_ENVIORNMENT_SUCCESS';

export const SET_CARD_PRE_REQUEST='SET_CARD_PRE_REQUEST';
export const STE_CARD_TOKEN_CREATED='STE_CARD_TOKEN_CREATED';
export const SET_CARD_PAYMENT_REPLIED='SET_CARD_PAYMENT_REPLIED';

// Status
export const CARD_TOKEN_STATUS_UNKNOWN='N/A';
export const CARD_TOKEN_STATUS_REQUESTING='REQUESTING';
export const CARD_TOKEN_STATUS_CREATED='CREATED';
